{
  "round": {
    "x": 56,
    "y": 52,
    "w": 168,
    "h": 35,
    "lane": {
      "x": 40,
      "y": 42,
      "w": 196,
      "h": 54
    }
  },
  "target.label": {
    "x": 496,
    "y": 273,
    "w": 115,
    "h": 22,
    "lane": {
      "x": 486,
      "y": 268,
      "w": 128,
      "h": 30
    }
  },
  "question": {
    "x": 128,
    "y": 501,
    "w": 686,
    "h": 135,
    "lane": {
      "x": 80,
      "y": 494,
      "w": 780,
      "h": 142
    }
  },
  "instruction": {
    "x": 128,
    "y": 632,
    "w": 686,
    "h": 59,
    "lane": {
      "x": 80,
      "y": 632,
      "w": 782,
      "h": 62
    }
  },
  "marker.text": {
    "x": 700,
    "y": 986,
    "w": 106,
    "h": 48,
    "lane": {
      "x": 700,
      "y": 986,
      "w": 106,
      "h": 48
    }
  },
  "status.title": {
    "x": 219,
    "y": 1392,
    "w": 504,
    "h": 60,
    "lane": {
      "x": 150,
      "y": 1392,
      "w": 650,
      "h": 60
    }
  },
  "status.sub": {
    "x": 384,
    "y": 1450,
    "w": 200,
    "h": 26,
    "lane": {
      "x": 300,
      "y": 1450,
      "w": 340,
      "h": 42
    }
  },
  "allsix": {
    "x": 393,
    "y": 1307,
    "w": 160,
    "h": 22,
    "lane": {
      "x": 300,
      "y": 1280,
      "w": 360,
      "h": 70
    }
  }
}